// Stránky investičních bytů – klik na řádek tabulky nabídky otevře detail jednotky (stránku inzerátu).
// Markup: includes/template-parts/redesign/reality/nabidka.php – <tr data-re-href>. Na mobilu je
// sloupec s odkazem „Detail →“ skrytý a řádek je celý klikací jako v referenci; odkaz pro klávesnici
// a čtečky nese šipka ve sloupci stavu. Kliky na odkazy uvnitř řádku nechává prohlížeči.

export default function initRealityRows() {
  const rows = document.querySelectorAll('tr[data-re-href]');

  rows.forEach((row) => {
    row.addEventListener('click', (event) => {
      if (event.target.closest('a, button')) {
        return;
      }
      window.location.href = row.dataset.reHref;
    });
  });
}
